// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".selectable[data-v-2bb2612a]:hover {\n  cursor: pointer;\n}\n.borderBlue[data-v-2bb2612a] {\n  border-left: solid 4px var(--v-primaryBlue-base) !important;\n}\n.borderPurple[data-v-2bb2612a] {\n  border-left: solid 4px var(--v-secondaryPurple-base) !important;\n}\n.borderGreen[data-v-2bb2612a] {\n  border-left: solid 4px var(--v-primaryGreen-base) !important;\n}\n.emergencyChange[data-v-2bb2612a] {\n  color: var(--v-secondaryRed-base) !important;\n}", ""]);
// Exports
module.exports = exports;
